import { FC } from "react";
import PossessionGraph from "./PossessionGraph";
import StatisticGraph from "./StatisticGraph";

const MainSummaryGraph: FC<{ loading: boolean }> = ({ loading }) => {
  return (
    <div>
      <div
        className="mainListTitle"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        광고 통계
      </div>
      <div
        style={{
          display: "flex",
          marginLeft: "6px",
          gap: "20px",
          width: "100%",
        }}
      >
        <div
          style={{
            flex: 4,
            background: "#fff",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            minHeight: "300px",
            overflow: "hidden",
          }}
        >
          <PossessionGraph loading={loading} />
        </div>

        <div
          style={{
            flex: 3,
            background: "#fff",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            minHeight: "300px",
          }}
        >
          <StatisticGraph loading={loading} />
        </div>
      </div>
    </div>
  );
};

export default MainSummaryGraph;
